import { all, put, takeLatest } from 'redux-saga/effects'
import { CreateEventRequest, DeleteEventRequest, EventsActionTypes, UpdateEventRequest } from './types'
import {
  getEventsSuccess,
  getEventsFailure,
  createEventSuccess,
  createEventFailure,
  updateEventSuccess,
  updateEventFailure,
  deleteEventSuccess,
  deleteEventFailure,
} from './action'
import { apiV2, SdkResponse, wrapResponse } from '../../repositories/repository'

function* handleGetEvents() {
  const apiCall = apiV2.events.findAllForDoctor.bind(apiV2.events)
  const res = (yield wrapResponse(apiCall())) as SdkResponse<typeof apiCall>

  if (res.success) {
    yield put(getEventsSuccess(res.data))
  } else {
    yield put(getEventsFailure(res.error))
  }
}

function* handleCreateEvent({ data }: CreateEventRequest) {
  const apiCall = apiV2.events.create.bind(apiV2.events)
  const res = (yield wrapResponse(apiCall(data))) as SdkResponse<typeof apiCall>

  if (res.success) {
    yield put(createEventSuccess(res.data))
    yield handleGetEvents()
  } else {
    yield put(createEventFailure(res.error))
  }
}

function* handleUpdateEvent({ id, data }: UpdateEventRequest) {
  const apiCall = apiV2.events.update.bind(apiV2.events)
  const res = (yield wrapResponse(apiCall(id, data))) as SdkResponse<typeof apiCall>

  if (res.success) {
    yield put(updateEventSuccess(res.data))
    yield handleGetEvents()
  } else {
    yield put(updateEventFailure(res.error))
  }
}

function* handleDeleteEvent({ id }: DeleteEventRequest) {
  const apiCall = apiV2.events.delete.bind(apiV2.events)
  const res = (yield wrapResponse(apiCall(id))) as SdkResponse<typeof apiCall>

  if (res.success) {
    yield put(deleteEventSuccess())
    yield handleGetEvents()
  } else {
    yield put(deleteEventFailure(res.error))
  }
}

function* eventsSaga() {
  yield all([
    takeLatest(EventsActionTypes.GET_EVENTS_REQUEST, handleGetEvents),
    takeLatest(EventsActionTypes.CREATE_EVENT_REQUEST, handleCreateEvent),
    takeLatest(EventsActionTypes.UPDATE_EVENT_REQUEST, handleUpdateEvent),
    takeLatest(EventsActionTypes.DELETE_EVENT_REQUEST, handleDeleteEvent),
  ])
}

export default eventsSaga
